import { render, staticRenderFns } from "./StateWiseQuantity.vue?vue&type=template&id=9f045f9c&"
import script from "./StateWiseQuantity.vue?vue&type=script&lang=js&"
export * from "./StateWiseQuantity.vue?vue&type=script&lang=js&"
import style0 from "./StateWiseQuantity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports